import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../common/components/Icon';

function MobileAppModal() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(false);

    // Проверяем, является ли устройство мобильным
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Показываем модал только на главной странице и на мобильных устройствах
    useEffect(() => {
        if (location.pathname === '/' && isMobile) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [location.pathname, isMobile]);

    const handleClose = () => {
        setIsVisible(false);
    };

    const handleAppStoreClick = () => {
        window.open('https://apps.apple.com/kz/app/agroland/id6743326709', '_blank');
    };

    const handleGooglePlayClick = () => {
        window.open('https://play.google.com/store/apps/details?id=com.agroland.app&hl=en', '_blank');
    };

    if (!isVisible || !isMobile) {
        return null;
    }

    return (
        <div className="fixed inset-x-0 bottom-0 z-[1000] flex justify-center items-end md:hidden">
            <div className="w-full max-w-md bg-white rounded-t-2xl shadow-[0_-4px_20px_rgba(0,0,0,0.15)] px-4 pt-4 pb-5 relative">
                <button
                    onClick={handleClose}
                    className="absolute top-3 right-3 bg-white hover:bg-gray-100 rounded-full p-1.5 flex items-center justify-center border-2 border-[#147F26]"
                    aria-label="Close"
                >
                    <Icon src="x" alt="close" className="w-3 h-3" />
                </button>

                <div className="pt-4">
                    <h3 className="text-base font-semibold text-gray-900 text-center mb-1">
                        {t('downloadApp')}
                    </h3>
                    <p className="text-sm text-gray-600 text-center mb-4">
                        {t('downloadAppDescription')}
                    </p>

                    <div className="flex flex-col gap-3 w-full">
                        <button
                            onClick={handleAppStoreClick}
                            className="w-full flex items-center justify-center gap-2 rounded-xl bg-black text-white h-11 active:opacity-80"
                        >
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/App_Store_%28iOS%29.svg/960px-App_Store_%28iOS%29.svg.png"
                                alt="App Store"
                                className="w-6 h-6 object-contain"
                            />
                            <span className="text-sm font-semibold">App Store</span>
                        </button>

                        <button
                            onClick={handleGooglePlayClick}
                            className="w-full flex items-center justify-center gap-2 rounded-xl bg-[#147F26] text-white h-11 active:bg-[#7AB30E]"
                        >
                            <img
                                src="https://avatanplus.com/files/resources/original/5a8047a98f64c1618517ee73.png"
                                alt="Google Play"
                                className="w-6 h-6 object-contain"
                            />
                            <span className="text-sm font-semibold">Google Play</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobileAppModal;
